import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "cv-wrapper" }
const _hoisted_2 = {
  id: "cv-printable-area",
  class: "cv-container"
}
const _hoisted_3 = { class: "cv-layout" }
const _hoisted_4 = { class: "cv-sidebar" }
const _hoisted_5 = { class: "sidebar-section" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = { class: "info-label" }
const _hoisted_8 = { class: "info-item" }
const _hoisted_9 = { class: "info-label" }
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = { class: "info-label" }
const _hoisted_13 = { class: "info-value" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = { class: "info-label" }
const _hoisted_16 = { class: "info-value" }
const _hoisted_17 = { class: "info-item" }
const _hoisted_18 = { class: "info-label" }
const _hoisted_19 = { class: "info-value" }
const _hoisted_20 = { class: "info-item" }
const _hoisted_21 = { class: "info-label" }
const _hoisted_22 = { class: "info-value" }
const _hoisted_23 = { class: "sidebar-section" }
const _hoisted_24 = { class: "skill-category" }
const _hoisted_25 = { class: "skill-category" }
const _hoisted_26 = { class: "skill-category" }
const _hoisted_27 = { class: "skill-category" }
const _hoisted_28 = { class: "sidebar-section" }
const _hoisted_29 = { class: "language-item" }
const _hoisted_30 = { class: "language-name" }
const _hoisted_31 = { class: "language-level" }
const _hoisted_32 = { class: "language-item" }
const _hoisted_33 = { class: "language-name" }
const _hoisted_34 = { class: "language-level" }
const _hoisted_35 = { class: "language-item" }
const _hoisted_36 = { class: "language-name" }
const _hoisted_37 = { class: "language-level" }
const _hoisted_38 = { class: "sidebar-section print-only-section" }
const _hoisted_39 = { class: "interests-grid" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "cv-main" }
const _hoisted_42 = { class: "cv-header" }
const _hoisted_43 = { class: "header-content" }
const _hoisted_44 = { class: "subtitle" }
const _hoisted_45 = { class: "motivation" }
const _hoisted_46 = { class: "objective" }
const _hoisted_47 = { class: "links" }
const _hoisted_48 = { class: "main-section" }
const _hoisted_49 = { class: "experience-item" }
const _hoisted_50 = { class: "company" }
const _hoisted_51 = { class: "period" }
const _hoisted_52 = { class: "experience-item" }
const _hoisted_53 = { class: "company" }
const _hoisted_54 = { class: "period" }
const _hoisted_55 = { class: "description" }
const _hoisted_56 = { class: "experience-item" }
const _hoisted_57 = { class: "company" }
const _hoisted_58 = { class: "period" }
const _hoisted_59 = { class: "description" }
const _hoisted_60 = { class: "main-section" }
const _hoisted_61 = { class: "experience-item" }
const _hoisted_62 = { class: "company" }
const _hoisted_63 = { class: "main-section" }
const _hoisted_64 = { class: "formation-item" }
const _hoisted_65 = { class: "institution" }
const _hoisted_66 = { class: "period" }
const _hoisted_67 = { class: "description" }
const _hoisted_68 = { class: "formation-item" }
const _hoisted_69 = { class: "mention" }
const _hoisted_70 = { class: "institution" }
const _hoisted_71 = { class: "period" }
const _hoisted_72 = { class: "formation-item" }
const _hoisted_73 = { class: "mention" }
const _hoisted_74 = { class: "institution" }
const _hoisted_75 = { class: "period" }
const _hoisted_76 = { class: "main-section" }
const _hoisted_77 = { class: "about-subsection" }
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = { class: "about-subsection main-interests" }
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = { class: "export-section" }
const _hoisted_83 = ["href"]
const _hoisted_84 = { class: "btn-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("aside", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "photo-container" }, [
              _createElementVNode("div", { class: "profile-photo-sidebar" }, [
                _createElementVNode("img", {
                  src: "/PP.png",
                  alt: "Photo de profil"
                })
              ])
            ], -1)),
            _createElementVNode("section", _hoisted_5, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cv.personalInfo')), 1),
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "mdi mdi-email" }, null, -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('cv.email')), 1)
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "info-value" }, "raphael.girardy@outlook.com", -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "mdi mdi-map-marker" }, null, -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('cv.address')), 1)
              ]),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('cv.addressValue')), 1),
              _createElementVNode("div", _hoisted_11, [
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "mdi mdi-phone" }, null, -1)),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('cv.phone')), 1)
              ]),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('cv.phoneValue')), 1),
              _createElementVNode("div", _hoisted_14, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "mdi mdi-calendar" }, null, -1)),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('cv.birthdate')), 1)
              ]),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('cv.birthdateValue')), 1),
              _createElementVNode("div", _hoisted_17, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "mdi mdi-flag" }, null, -1)),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('cv.nationality')), 1)
              ]),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('cv.nationalityValue')), 1),
              _createElementVNode("div", _hoisted_20, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "mdi mdi-car" }, null, -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('cv.license')), 1)
              ]),
              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('cv.licenseValue')), 1)
            ]),
            _createElementVNode("section", _hoisted_23, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cv.skillsTitle')), 1),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('cv.skillBackend')), 1),
                _cache[9] || (_cache[9] = _createElementVNode("ul", { class: "skills-list" }, [
                  _createElementVNode("li", null, "Java, Spring Boot, WebFlux"),
                  _createElementVNode("li", null, "Node.js, GraphQL, REST"),
                  _createElementVNode("li", null, "PostgreSQL, Redis, MongoDB"),
                  _createElementVNode("li", null, "Design Patterns, SOLID")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('cv.skillFrontend')), 1),
                _cache[10] || (_cache[10] = _createElementVNode("ul", { class: "skills-list" }, [
                  _createElementVNode("li", null, "Vue.js, TypeScript")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('cv.skillDevOps')), 1),
                _cache[11] || (_cache[11] = _createElementVNode("ul", { class: "skills-list" }, [
                  _createElementVNode("li", null, "Docker, Kubernetes (K3s)"),
                  _createElementVNode("li", null, "GitLab CI/CD, ArgoCD"),
                  _createElementVNode("li", null, "Proxmox, Linux"),
                  _createElementVNode("li", null, "Prometheus, Grafana")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('cv.skillTools')), 1),
                _cache[12] || (_cache[12] = _createElementVNode("ul", { class: "skills-list" }, [
                  _createElementVNode("li", null, "Git, GitHub, GitLab"),
                  _createElementVNode("li", null, "C, C++, Python")
                ], -1))
              ])
            ]),
            _createElementVNode("section", _hoisted_28, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cv.languagesTitle')), 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('cv.langFrench')), 1),
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('cv.langFrenchLevel')), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('cv.langEnglish')), 1),
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('cv.langEnglishLevel')), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('cv.langSpanish')), 1),
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('cv.langSpanishLevel')), 1)
              ])
            ]),
            _createElementVNode("section", _hoisted_38, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cv.aboutInterestsTitle')), 1),
              _createElementVNode("div", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interestsList, (interest, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "interest-item"
                  }, [
                    _createElementVNode("span", {
                      innerHTML: interest.trim()
                    }, null, 8, _hoisted_40)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("main", _hoisted_41, [
            _createElementVNode("header", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('cv.name')), 1),
                _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('cv.subtitle')), 1),
                _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('cv.motivation')), 1),
                _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t('cv.objective')), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cv.portfolioLabel')) + " ", 1),
                    _createElementVNode("a", {
                      href: "https://raphael-girardy.fr",
                      target: "_blank",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.posthog.capture('cv_portfolio_link_clicked')))
                    }, "raphael-girardy.fr")
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_48, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cv.experiencesTitle')), 1),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.exp1Title')), 1),
                _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t('cv.exp1Company')), 1),
                _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('cv.exp1Period')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('cv.exp1Desc1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('cv.exp1Desc2')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.exp2Title')), 1),
                _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.$t('cv.exp2Company')), 1),
                _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.$t('cv.exp2Period')), 1),
                _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t('cv.exp2Desc')), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.exp3Title')), 1),
                _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.$t('cv.exp3Company')), 1),
                _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t('cv.exp3Period')), 1),
                _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('cv.exp3Desc')), 1)
              ])
            ]),
            _createElementVNode("section", _hoisted_60, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cv.projectsTitle')), 1),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.proj1Title')), 1),
                _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t('cv.proj1Subtitle')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('cv.proj1Desc1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('cv.proj1Desc2')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('cv.proj1Desc3')), 1)
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_63, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cv.formationsTitle')), 1),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.form1Title')), 1),
                _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.$t('cv.form1Institution')), 1),
                _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.$t('cv.form1Period')), 1),
                _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t('cv.form1Desc')), 1)
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("h3", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('cv.form2Title')) + " ", 1),
                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t('cv.form2Mention')), 1)
                ]),
                _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.$t('cv.form2Institution')), 1),
                _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.$t('cv.form2Period')), 1)
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("h3", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('cv.form3Title')) + " ", 1),
                  _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$t('cv.form3Mention')), 1)
                ]),
                _createElementVNode("p", _hoisted_74, _toDisplayString(_ctx.$t('cv.form3Institution')), 1),
                _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.$t('cv.form3Period')), 1)
              ])
            ]),
            _createElementVNode("section", _hoisted_76, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cv.aboutTitle')), 1),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.aboutProjectTitle')), 1),
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('cv.aboutProject1')
                }, null, 8, _hoisted_78),
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('cv.aboutProject2')
                }, null, 8, _hoisted_79)
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.aboutInterestsTitle')), 1),
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('cv.aboutInterests')
                }, null, 8, _hoisted_81)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("a", {
          href: _ctx.cvPdfUrl,
          download: "",
          target: "_blank",
          class: "export-btn ln-glass-elevated",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.trackDownload && _ctx.trackDownload(...args)))
        }, [
          _createElementVNode("span", _hoisted_84, [
            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "mdi mdi-download" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('cv.exportButton')), 1)
          ])
        ], 8, _hoisted_83)
      ])
    ])
  ], 64))
}